// extracted by mini-css-extract-plugin
export default {"sendBidForm":"modal_sendBidForm__l8TqX","uploadedFileBlock":"modal_uploadedFileBlock__6Xunn"};